import { openBlock as t, createElementBlock as a, createStaticVNode as l } from "vue";
const h = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, e = /* @__PURE__ */ l('<path fill="#FFDA44" d="M28.696 1.985A19.92 19.92 0 0 0 20 0a19.92 19.92 0 0 0-8.696 1.985L9.565 20l1.74 18.015A19.921 19.921 0 0 0 20 40a19.92 19.92 0 0 0 8.696-1.985L30.435 20l-1.74-18.015Z"></path><path fill="#0052B4" d="M11.304 1.985C4.614 5.219 0 12.07 0 20s4.615 14.78 11.304 18.015V1.985Z"></path><path fill="#D80027" d="M28.696 1.985v36.03C35.386 34.781 40 27.93 40 20S35.386 5.22 28.696 1.985Z"></path><path fill="#FF9811" d="M26.956 15.736h-4.782a2.174 2.174 0 1 0-4.348 0h-4.783c0 1.182 1.03 2.14 2.212 2.14h-.071a2.14 2.14 0 0 0 2.14 2.14 2.14 2.14 0 0 0 1.745 2.103l-1.687 3.808a6.934 6.934 0 0 0 2.618.511c.926 0 1.81-.182 2.618-.511l-1.687-3.808a2.14 2.14 0 0 0 1.744-2.102 2.14 2.14 0 0 0 2.141-2.14h-.071c1.182 0 2.211-.96 2.211-2.141Z"></path><path fill="#0052B4" d="M20 18.696 17.174 20v2.609L20 24.348l2.826-1.74V20L20 18.696Z"></path><path fill="#D80027" d="M17.174 17.391h5.652V20h-5.652v-2.609Z"></path>', 6), o = [
  e
];
function c(p, d) {
  return t(), a("svg", h, [...o]);
}
const n = { render: c };
export {
  n as default,
  c as render
};
